<template>
  <li class="nav-item ps-4">
    <a class="nav-link" :href="(es ? '/alquiler-habitacion-leon' : '/en/room-rental-leon') + '?showAll=true&type=room'">{{ $t('roomsM') }}</a>
  </li>
  <li class="nav-item ps-4">
    <a class="nav-link" :href="(es ? '/alquiler-piso-leon' : '/en/apartment-rental-leon') + '?showAll=true&type=apartment'">{{ $t('apartments') }}</a>
  </li>
  <li class="nav-item ps-4">
    <a class="nav-link" :href="es ? '/preguntas-frecuentes' : '/en/faq'">{{ $t('faqM') }}</a>
  </li>
  <li class="nav-item ps-4">
    <a class="nav-link" :href="es ? '/contacto' : '/en/contact'">{{ $t('contact') }}</a>
  </li>
  <li class="nav-item ps-4">
    <a class="nav-link" @click="toggleLanguage" style="cursor: pointer;">
      <img :src="require('@/assets/img/es.png')" alt="language" class="lang-icon" v-if="!es">
      <img :src="require('@/assets/img/en.png')" alt="language" class="lang-icon" v-if="es">
    </a>
  </li>
</template>

<script>
export default {
  name: 'AppMenuItems',
  data() {
    return {}
  },
  computed: {
    es() {
      return this.$i18n.locale === 'es';
    }
  },
  methods: {
    toggleLanguage() {
      this.$i18n.locale = this.es ? 'en' : 'es';
      localStorage.setItem('lang', this.$i18n.locale);
      window.location.reload();
    }
  }
}
</script>